import axios from 'axios'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../components/Header/header'
import Scratch from '../../components/Scratch/scratch'
import config from '../../config/request.config'
import { AppContainer, Button, ContentContainer, FooterContainer } from './styled'

const GameScratch: React.FC = () => {
  const navigate = useNavigate();
  const [winner, setWinner] = React.useState<boolean>(false);
  const [concluded, setConcluded] = React.useState<boolean>(false);
  const [prize, setPrize] = React.useState<any>(null); // Prêmio atual
  const [currentSpin, setCurrentSpin] = React.useState<number>(1); // Jogada atual
  const [totalSpins, setTotalSpins] = React.useState<number>(1); // Total de jogadas permitidas

  // Função para buscar o prêmio sorteado
  const fetchRandomPrize = async () => {
    const oxCustom = localStorage.getItem('oxCustom');
    let user = localStorage.getItem('isAuthenticated');
    user = user?.toLowerCase() || user;

    if (!oxCustom || !user) {
      alert('Ops, falha ao salvar o cadastro!');
      return;
    }

    const formData = {
      oxCustom: JSON.parse(oxCustom),
    };
    formData.oxCustom.user = user;

    try {
      const response = await axios.get(`${config.HOST}:${config.PORT}/v1/prizedraw/draw-random`);
      if (response.data) {
        formData.oxCustom.prizedraw = response.data;
        sendFormData(formData); // Envia os dados do prêmio atual
        setWinner(true); // Define que o jogador ganhou
        setPrize(response.data); // Armazena o prêmio atual
      } else {
        setWinner(false); // Define que não há prêmios disponíveis
        setPrize(null);
      }
    } catch (error) {
      console.error('Erro ao buscar o prêmio sorteado:', error);
      setWinner(false);
    }
  };

  const sendFormData = async (body: any) => {
    try {
      await axios.post(`${config.HOST}:${config.PORT}/v1/subscription`, body).catch((error) => {
        alert('Ops, servidor desativado!');
        console.log('Erro:', error.message);
      });
    } catch (error) {
      console.error('Erro ao enviar o formulário:', error);
    }
  };

  const handleNextSpin = () => {
    if (currentSpin < totalSpins) {
      setCurrentSpin(currentSpin + 1); // Avança para a próxima jogada
      setWinner(false); // Reseta o estado de vencedor
      setPrize(null); // Limpa o prêmio atual
      fetchRandomPrize(); // Sorteia novamente
    } else {
      navigate('/register'); // Finaliza e volta para a página inicial
    }
  };

  useEffect(() => {
    // Determina o número de jogadas permitidas com base no clienteXpVisa
    const oxCustom = JSON.parse(localStorage.getItem('oxCustom') || '{}');
    const spins = oxCustom.clienteXpVisa === 'Sim' ? 2 : 1;
    setTotalSpins(spins);

    // Busca o primeiro prêmio
    fetchRandomPrize();
  }, []);

  return (
    <AppContainer>
      <Header />
      <ContentContainer>
        {prize && (
          <Scratch
            winner={winner}
            number={prize.number || 0} // Número calculado
            concluded={concluded}
            countprizes={prize.quantidadeAtual || 0} // Quantidade restante
            imageId={prize.id} // ID do prêmio associado à imagem
          />
        )}
      </ContentContainer>
      <FooterContainer>
        <Button onClick={handleNextSpin}>
          {currentSpin < totalSpins ? 'CONTINUAR' : 'FINALIZAR'}
        </Button>
      </FooterContainer>
    </AppContainer>
  );
};

export default GameScratch;
